import gql from 'graphql-tag';

const ADD_PATCH_VIEW = gql`
  mutation($input: ListViewInput!) {
    addPatchView(input: $input) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const GET_PATCH_VIEW = gql`
  query($id: ID!) {
    getPatchView(id: $id) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const GET_ALL_POLICY_SET_BY_CLASS_ID_PATCH = gql`
  query getAllPolicySetByClassId($classId: ID!, $category: String) {
    getAllPolicySetByClassId(classId: $classId, category: $category) {
      policySetId
      name
      category
    }
  }
`;

const UPDATE_PATCH_VIEW = gql`
  mutation($id: ID!, $input: ListViewInput!) {
    updatePatchView(id: $id, input: $input) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const DELETE_PATCH_VIEW = gql`
  mutation($id: ID!) {
    deletePatchView(id: $id)
  }
`;

const GET_PATCH_VIEW_LIST = gql`
  query {
    getPatchViews {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const GET_RMM_SIDEBAR_LIST_V2 = gql`
  query getViews($modules: [ID!]) {
    getViews(modules: $modules) {
      module
      views {
        id
        name
        module
        viewCondition
        customView
        shared
        systemViewProperty
        viewSubType
        deprecated
      }
    }
  }
`;
// only if advanced hierarchy
const GET_PATCH_SUPPORTED_ASSET_CLASS = gql`
  query getPatchSupportedAssetClass {
    getPatchSupportedAssetClass {
      classId
      name
    }
  }
`;
// only if advanced hierarchy

const GET_PATCH_ASSET_LIST_VIEW_BY_CLASS_ID_META = gql`
  query {
    getPatchAssetListViewMetaByClassId
  }
`;

const GET_PATCH_ENABLED_POLICY_SET_BY_CLASSID = gql`
  query getPatchEnabledPoliciesByClassId(
    $classId: ID!
    $patchId: ID
    $approvalState: String
  ) {
    getPatchEnabledPoliciesByClassId(
      classId: $classId
      patchId: $patchId
      approvalState: $approvalState
    ) {
      policyId
      name
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      asset {
        name
        assetId
      }
      policySet {
        name
        policySetId
        category
      }
      selectionType
    }
  }
`;

const GET_PATCH_LIST_V2 = gql`
  query getPatchListV2(
    $classId: ID
    $listInfo: ListInfoInput!
    $fetchHistoryPatch: Boolean
  ) {
    getPatchListV2(
      classId: $classId
      listInfo: $listInfo
      fetchHistoryPatch: $fetchHistoryPatch
    ) {
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
      patches {
        patchId
        patchKey
        title
        publishedDate
        category
        severity
        # approvalStatus
        # approvalBy
        # approvalByDetails
        # approvalTime
        # totalDeviceCount
        installedDeviceCount
        newOrMissingDeviceCount
        rebootRequiredDeviceCount
        failedDeviceCount
        installedPercent
        rebootRequiredPercent
        failedPercent
        kbNumbers {
          kbNumber
        }
        # account {
        #   accountId
        #   name
        # }
        # site {
        #   id
        #   name
        # }
        version
        size
        assetClass {
          classId
          name
        }
        associatedAssets
        summary {
          status
          lastUpdatedTime
          data
        }
        sentiment {
          status
          severity
          data
        }
        knownIssues {
          severity
          description
        }
        stabilitySeverity
        patchUninstallable
        maxCVSSScore
      }
    }
  }
`;

const GET_PATCH_LIST_AI_SUMMARY = gql`
  query getPatchDetail(
    $patchId: ID!
    $kbNumber: String
    $listInfo: ListInfoInput!
    $fetchHistoryPatch: Boolean
  ) {
    getPatchDetail(
      patchId: $patchId
      kbNumber: $kbNumber
      listInfo: $listInfo
      fetchHistoryPatch: $fetchHistoryPatch
    ) {
      patchId
      title
      publishedDate
      severity
      category
      version
      size
      associatedAssets

      installedDeviceCount
      newOrMissingDeviceCount
      rebootRequiredDeviceCount
      failedDeviceCount
      installedPercent
      rebootRequiredPercent
      failedPercent
      patchUninstallable
      approvedDeviceCount
      rejectedDeviceCount
      deferredDeviceCount
      approvalPendingDeviceCount
      kbNumbers {
        kbNumber
      }
      associatedAssets
      telemetry {
        installedCount
        rejectedCount
        rolledBackActionCount
      }
      summary {
        data
        lastUpdatedTime
        status
      }
      sentiment {
        lastUpdatedTime
        data
        status
        severity
      }
      knownIssues {
        description
        count
        severity
      }
      stability {
        data
        severity
      }
      maxCVSSDetail {
        cveNumber
        cvssScore
        severity
      }
    }
  }
`;

const APPROVE_PATCH = gql`
  mutation($patchId: ID!) {
    updatePatchApprovalStatus(
      patchId: $patchId
      input: { approvalStatus: "Approved" }
    )
  }
`;

const REJECT_PATCH = gql`
  mutation($patchId: ID!) {
    updatePatchApprovalStatus(
      patchId: $patchId
      input: { approvalStatus: "Rejected" }
    )
  }
`;

const APPROVE_PATCH_IN_ASSET_LEVEL = gql`
  mutation($assetId: ID!, $patchId: ID!) {
    updateAssetPatchApprovalStatus(
      assetId: $assetId
      patchId: $patchId
      input: { approvalStatus: "Approved" }
    )
  }
`;

const REJECT_PATCH_IN_ASSET_LEVEL = gql`
  mutation($assetId: ID!, $patchId: ID!) {
    updateAssetPatchApprovalStatus(
      assetId: $assetId
      patchId: $patchId
      input: { approvalStatus: "Rejected" }
    )
  }
`;
const APPROVE_INSTALL_ASSET_PAGE = gql`
  mutation(
    $assetId: ID!
    $patchIds: [ID!]
    $approve: Boolean!
    $install: Boolean!
  ) {
    approveAndInstallAssetPatches(
      assetId: $assetId
      patchIds: $patchIds
      approve: $approve
      install: $install
    )
  }
`;
const APPROVE_INSTALL_ALL_PATCH_PAGE = gql`
  mutation($patchIds: [ID!], $approve: Boolean!, $install: Boolean!) {
    approveAndInstallPatches(
      patchIds: $patchIds
      approve: $approve
      install: $install
    )
  }
`;
const APPROVE_INSTALL_ALL_PATCH_SLIDER_PAGE = gql`
  mutation(
    $assetIds: [ID!]
    $patchId: ID!
    $approve: Boolean!
    $install: Boolean!
  ) {
    approveAndInstallPatchAssets(
      assetIds: $assetIds
      patchId: $patchId
      approve: $approve
      install: $install
    )
  }
`;
const UPDATE_MULTI_PATCH_ASSET_APPROVAL = gql`
  mutation updateMultiPatchAssetApprovalStatus(
    $patchId: ID!
    $assetIds: [ID!]
    $approvalStatus: String
  ) {
    updateMultiPatchAssetApprovalStatus(
      patchId: $patchId
      assetIds: $assetIds
      approvalStatus: $approvalStatus
    )
  }
`;
const GET_PATCH_CATEGORY_SEVERITY = gql`
  query {
    getPatchAllCategorySeverityMeta {
      categories {
        patchCategoryId
        name
      }
      severities {
        patchSeverityId
        name
      }
    }
  }
`;
const GET_PATCH_APPROVAL_STATUS_META = gql`
  query {
    getPatchApprovalStatusMeta
  }
`;
const GET_PATCH_DETAIL_VIEW_LIST_META_INFO = gql`
  query {
    getPatchDetailListViewMetaInfoV2
  }
`;
const GET_PATCH_VIEW_CONDITION_META_INFO = gql`
  query {
    getPatchViewConditionMetaInfo
  }
`;
const GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID = gql`
  query($classId: ID, $viewId: ID!) {
    getPatchListViewMetaInfoByClassIdAndViewId(
      classId: $classId
      viewId: $viewId
    )
  }
`;

const GET_PATCH_DETAILS_LISTVIEW_META = gql`
  query {
    getPatchDetailListViewMetaInfo
  }
`;

const GET_ASSET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID = gql`
  query($classId: ID!) {
    getAssetPatchListViewMetaInfoByClassIdV2(classId: $classId)
  }
`;

const GET_CONDITIONS_META_FOR_RMM_REPORTS = gql`
  query {
    getConditionsMetaForRmmReports
  }
`;
const GET_CONDITIONS_META_FOR_RMM_MODULE_REPORTS = gql`
  query($rmmModule: String) {
    getConditionsMetaForRmmReports(rmmModule: $rmmModule)
  }
`;

const GET_SOFTWARELIST_META = gql`
  query {
    getConditionsMetaForRmmReports(rmmModule: "AssetSoftwareInventory")
  }
`;

const GET_NMAsset_META = gql`
  query {
    getConditionsMetaForRmmReports(rmmModule: "NMAsset")
  }
`;

const GET_ALL_ASSETS_META = gql`
  query {
    getConditionsMetaForRmmReports(rmmModule: "AllAssets")
  }
`;

const GET_PATCH_ASSET_LIST = gql`
  query(
    $patchId: ID!
    $listInfo: ListInfoInput!
    $clientId: ID
    $siteId: ID
    $installationStatus: String
    $fetchHistoryPatch: Boolean
  ) {
    getPatchAssetList(
      patchId: $patchId
      listInfo: $listInfo
      clientId: $clientId
      siteId: $siteId
      installationStatus: $installationStatus
      fetchHistoryPatch: $fetchHistoryPatch
    ) {
      assetPatches {
        asset {
          assetId
          name
          assetClass {
            classId
          }
          client {
            accountId
            name
          }
          site {
            id
            name
          }
        }
        assetUninstallable
        approvalStatus
        installationStatus
        failedMessage
      }
      listInfo {
        totalCount
        page
        pageSize
        hasMore
      }
    }
  }
`;

const GET_PATCH_INSTALLED_ASSET_LIST = gql`
  query($patchId: ID!, $listInfo: ListInfoInput!) {
    getPatchInstalledAssetList(patchId: $patchId, listInfo: $listInfo) {
      assetPatches {
        asset {
          assetId
          name
          assetClass {
            classId
          }
          client {
            accountId
            name
          }
          site {
            id
            name
          }
        }
        approvalStatus
        installationStatus
        failedMessage
      }
      listInfo {
        totalCount
        page
        pageSize
        hasMore
      }
    }
  }
`;

const GET_PATCH_FAILED_ASSET_LIST = gql`
  query($patchId: ID!, $listInfo: ListInfoInput!) {
    getPatchFailedAssetList(patchId: $patchId, listInfo: $listInfo) {
      assetPatches {
        asset {
          assetId
          name
          assetClass {
            classId
          }
          client {
            accountId
            name
          }
          site {
            id
            name
          }
        }
        approvalStatus
        installationStatus
        failedMessage
      }
      listInfo {
        totalCount
        page
        pageSize
        hasMore
      }
    }
  }
`;
const GET_PATCH_ASSET_DETAIL_LIST_VIEW_META = gql`
  query {
    getPatchAssetsDetailListViewMetaInfo
  }
`;
const GET_PATCH_ASSET_DETAIL_LIST_VIEW_META_V2 = gql`
  query($classId: ID) {
    getPatchAssetsDetailListViewMetaInfoV2(classId: $classId)
  }
`;

const EXECUTE_PATCH_ASSET_ACTION = gql`
  mutation($input: PatchAssetActionInput!) {
    executePatchAssetAction(input: $input)
  }
`;

const EXECUTE_PATCH_ACTION = gql`
  mutation($input: PatchActionInput!) {
    executePatchAction(input: $input)
  }
`;

const EXECUTE_ASSET_PATCH_ACTION = gql`
  mutation($input: AssetPatchActionInput!) {
    executeAssetPatchAction(input: $input)
  }
`;
const GET_PATCH_CVE_LIST = gql`
  query getPatchCVEList(
    $patchId: ID!
    $kbNumber: String
    $listInfo: ListInfoInput!
  ) {
    getPatchCVEList(
      patchId: $patchId
      kbNumber: $kbNumber
      listInfo: $listInfo
    ) {
      listInfo {
        totalCount
        page
        pageSize
        sort {
          attribute
          order
        }
      }
      maxCVSSDetail {
        cveNumber
        cvssScore
        severity
      }
      cvssDetails {
        cveNumber
        cvssScore
        severity
      }
    }
  }
`;

const GET_PATCH_CVSS_DETAIL_META_INFO = gql`
  query {
    getPatchCVSSDetailMetaInfo
  }
`;
const ADD_AI_AGENT_FEEDBACK = gql`
  mutation($input: AddAIAgentFeedbackInput!) {
    addAIAgentFeedback(input: $input)
  }
`;

export {
  ADD_PATCH_VIEW,
  GET_PATCH_VIEW,
  UPDATE_PATCH_VIEW,
  DELETE_PATCH_VIEW,
  GET_PATCH_DETAILS_LISTVIEW_META,
  GET_PATCH_VIEW_LIST,
  APPROVE_PATCH,
  REJECT_PATCH,
  GET_PATCH_CATEGORY_SEVERITY,
  GET_PATCH_DETAIL_VIEW_LIST_META_INFO,
  GET_PATCH_ASSET_LIST,
  GET_PATCH_INSTALLED_ASSET_LIST,
  GET_PATCH_FAILED_ASSET_LIST,
  APPROVE_PATCH_IN_ASSET_LEVEL,
  REJECT_PATCH_IN_ASSET_LEVEL,
  GET_ASSET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID,
  GET_CONDITIONS_META_FOR_RMM_REPORTS,
  GET_SOFTWARELIST_META,
  GET_NMAsset_META,
  GET_ALL_ASSETS_META,
  APPROVE_INSTALL_ASSET_PAGE,
  GET_CONDITIONS_META_FOR_RMM_MODULE_REPORTS,
  APPROVE_INSTALL_ALL_PATCH_PAGE,
  APPROVE_INSTALL_ALL_PATCH_SLIDER_PAGE,
  UPDATE_MULTI_PATCH_ASSET_APPROVAL,
  GET_PATCH_APPROVAL_STATUS_META,
  GET_PATCH_ASSET_DETAIL_LIST_VIEW_META,
  GET_PATCH_SUPPORTED_ASSET_CLASS,
  GET_PATCH_ASSET_LIST_VIEW_BY_CLASS_ID_META,
  GET_PATCH_ENABLED_POLICY_SET_BY_CLASSID,
  GET_PATCH_LIST_V2,
  GET_RMM_SIDEBAR_LIST_V2,
  GET_PATCH_ASSET_DETAIL_LIST_VIEW_META_V2,
  EXECUTE_PATCH_ASSET_ACTION,
  EXECUTE_PATCH_ACTION,
  EXECUTE_ASSET_PATCH_ACTION,
  GET_PATCH_VIEW_CONDITION_META_INFO,
  GET_PATCH_LIST_AI_SUMMARY,
  GET_ALL_POLICY_SET_BY_CLASS_ID_PATCH,
  GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID,
  GET_PATCH_CVE_LIST,
  GET_PATCH_CVSS_DETAIL_META_INFO,
  ADD_AI_AGENT_FEEDBACK
};
